import { __module as _nodeUtil } from "./auth-service-tools1229.js";
import { _ as _freeGlobal } from "./auth-service-tools1011.js";
_nodeUtil.exports;

(function (module, exports) {
  var freeGlobal = _freeGlobal;
  var freeExports = exports && !exports.nodeType && exports;
  var freeModule = freeExports && true && module && !module.nodeType && module;
  var moduleExports = freeModule && freeModule.exports === freeExports;
  var freeProcess = moduleExports && freeGlobal.process;

  var nodeUtil = function () {
    try {
      var types = freeModule && freeModule.require && freeModule.require("util").types;

      if (types) {
        return types;
      }

      return freeProcess && freeProcess.binding && freeProcess.binding("util");
    } catch (e) {}
  }();

  module.exports = nodeUtil;
})(_nodeUtil, _nodeUtil.exports);

var _nodeUtilExports = _nodeUtil.exports;
export { _nodeUtilExports as _ };